module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAG0lEQVQImWOQEFH9DwIHTt/5z8SABBAcBgYGABD7CLfy7XiYAAAAAElFTkSuQmCC"